module.exports = __webpack_public_path__ + "static/media/dustbox_cap.ec1b7987.png";